import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getTiposMaquina, modifyTipoMaquina, removeTipoMaquina, addTipoMaquina, updateTiposMaquinaDB } from '../../actions/tipos_maquina_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresTipoMaquina extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getTiposMaquina();
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkCvTipoMaquina = (tipoMaquina) => {
        if (this.props.tiposMaquina.find(c => (c.descr === tipoMaquina.descr) && (c.id !== tipoMaquina.id))) {
            this.messageDialog(`Ya existe un tipo de máquina ${tipoMaquina.descr}`);
            return false;
        } else if (!tipoMaquina.descr.trim()) {
            this.messageDialog('Por favor, introduzca una descripción');
            return false;
        } else if (isNaN(tipoMaquina.cambio)) {
            this.messageDialog('Por favor, introduzca un valor para el campo Cambio');
            return false;
        }

        else return true;
    };

    newTipoMaquina = () => {
        this.props.openDialog('EditCvTipoMaquina', {
            cvTipoMaquina: {},
            okHandler: (tm) => {
                this.props.setSaveState(true);
                this.props.addTipoMaquina(tm);
            },
            checkTipoMaquina: this.checkCvTipoMaquina,
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, fromRowData, updated }) => {

        if(fromRow !== toRow) return; //solo modificamos una fila

        // for (let i = fromRow; i <= toRow; i++) {
        //     if (updated['cambio'] !== undefined) {
        //         if (updated['cambio']) updated['cambio'] = 1;
        //         else updated['cambio'] = 0;
        //     }
        //     let updatedRow = update(this.props.tiposMaquina[i], { $merge: updated });
        //     this.props.setSaveState(true);
        //     this.props.modifyTipoMaquina(updatedRow);
        // }


        if (updated['cambio'] !== undefined) {
            if (updated['cambio']) updated['cambio'] = 1;
            else updated['cambio'] = 0;
        }
        let updatedRow = update(this.props.tiposMaquina[fromRowData.grid_index], { $merge: updated });
        this.props.setSaveState(true);
        this.props.modifyTipoMaquina(updatedRow);


    };

    handleDeleteRow = tipoMaquina => {
        this.props.setSaveState(true);
        this.props.removeTipoMaquina(tipoMaquina);
    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div style={{ marginBottom: 20 }}>
                        <NeuriteGrid
                            id="m_a_t_m"
                            columns={[
                                { key: 'descr', name: 'Descripción', editable: true, dragable: false, width: 110 },
                                { key: 'cambio', name: 'Cambio', tooltip: 'Indica si es una máquina de cambio', type: 'bool', editable: true, dragable: false, width: 60 },
                                { key: 'regalo', name: 'Regalo', tooltip: 'Indica si proporciona regalo', type: 'bool', editable: true, dragable: false, width: 60 },
                                { key: 'tipoB', name: 'TipoB', tooltip: 'Indica si es máquina de tipo B', type: 'bool', editable: true, dragable: false, width: 55 },
                                { key: 'iRecaudacion', name: 'iRecaudacion', editable: true, type: 'int', dragable: false, width: 95, admin: true }
                            ]}
                            rows={this.props.tiposMaquina}
                            height={500}
                            buttonEdit={false}
                            buttonDelete={true}
                            buttonNew={true}
                            onNewRowClick={this.newTipoMaquina}
                            onRowsUpdated={this.handleGridRowsUpdated}
                            onDeleteClick={this.handleDeleteRow}
                            enableFilter={true}

                        />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.tiposMaquina.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateTiposMaquinaDB(this.props.tiposMaquina)
                }
                }>Guardar</Button>
            </div >
        );

    };

};

MaeAuxiliaresTipoMaquina.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    tiposMaquina: PropTypes.array.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getTiposMaquina: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyTipoMaquina: PropTypes.func.isRequired,
    removeTipoMaquina: PropTypes.func.isRequired,
    addTipoMaquina: PropTypes.func.isRequired,
    updateTiposMaquinaDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        tiposMaquina: state.tiposMaquina.tiposmaquina,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getTiposMaquina,
        openDialog,
        hideDialog,
        modifyTipoMaquina,
        removeTipoMaquina,
        addTipoMaquina,
        updateTiposMaquinaDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresTipoMaquina));

